import React, {useState} from 'react';
import {Box, Tab, Tabs, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import TemplateList from './TemplateList';
import TemplateCategories from './TemplateCategories';

const FormTemplates = () => {
    const navigate = useNavigate();
    const [tab, setTab] = useState(1);

    const handleChange = (_, value) => {
        if (value === 0) {
            navigate('/management/templates/create');
            return;
        }

        setTab(value);
    };

    return (
        <Box>
            <Typography variant="h5" py={3}>Form Templates</Typography>

            <Tabs
                value={tab}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                sx={{borderBottom: '1px solid #e5e7eb', mb: 3}}
            >
                <Tab label="Form Template Builder +" sx={{fontWeight: 700}} data-testid="tab-builder"/>
                <Tab label="Active Templates" data-testid="tab-active"/>
                <Tab label="Inactive Templates" data-testid="tab-inactive"/>
                <Tab label="Template Categories" data-testid="tab-categories"/>
            </Tabs>

            {tab === 1 && <TemplateList hidden={false}/>}
            {tab === 2 && <TemplateList hidden={true}/>}
            {tab === 3 && <TemplateCategories/>}
        </Box>
    );
};

export default FormTemplates;
